var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownMapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_simcard",
    "data-name": "vuesax/linear/simcard",
    transform: "translate(-364 -380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "simcard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.54,4.53,13.47,1.46A4.994,4.994,0,0,0,9.93,0H5A4.724,4.724,0,0,0,0,5V15a4.724,4.724,0,0,0,5,5h8a4.724,4.724,0,0,0,5-5V8.07A5,5,0,0,0,16.54,4.53Z",
    transform: "translate(367 382.01)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2,0,0,2,2,4",
    transform: "translate(371.5 394)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0,2,2,0,4",
    transform: "translate(378.5 394)",
    fill: "none",
    stroke: "#09A047",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(388 404) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownMapActive);
export default __webpack_public_path__ + "static/media/Unknown-map-active.acb80f82aea3413702efd1531b04f8b4.svg";
export { ForwardRef as ReactComponent };